<template>
  <div class="ma-4 px-4">
    <searchBar
      v-if="searchBar"
      @add="create"
      @updateSearch="(v) => (search = v)"
      @fileUploaded="initialise"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="subPartners"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
            :items-per-page="viewPartner ? itemsPerPage : 10"
            :hide-default-footer="viewPartner"
          >
            <template #[`item.action`]="{ item }">
              <v-icon
                :disabled="!item.active"
                small
                class="mr-2"
                color="accent"
                @click="edit(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.partner_id`]="{ value }">
              {{ getPartner(value) }}
            </template>
            <template #[`item.partner_approval_required`]="{ value }">
              {{ value ? "Yes" : "No" }}
            </template>
            <template #[`item.partner_payment_required`]="{ value }">
              {{ value ? "Yes" : "No" }}
            </template>
            <template #[`item.name`]="{ item }">
              <span
                :class="{
                  'accent--text': !viewPartner,
                }"
                :style="{
                  textDecoration: !viewPartner ? 'underline' : 'none',
                  cursor: !viewPartner ? 'pointer' : 'auto',
                }"
                @click="!viewPartner ? goToSubPartnerView(item.id) : ''"
              >
                {{ item.name }}
              </span>
            </template>
            <template #[`item.active`]="{ item }">
              <v-chip
                small
                :color="item.active ? 'green' : 'red'"
                dark
                @click="openConfirm(item)"
              >
                {{ showActiveStatus(item) }}
              </v-chip>
            </template>
            <template
              v-if="viewPartner && subPartners.length > 5 && itemsPerPage > 0"
              v-slot:footer
            >
              <div class="d-flex text--accent justify-end mx-3 pa-3">
                <span
                  @click="navigate()"
                  style="
                    cursor: pointer;
                    color: #4f4584;
                    text-decoration: underline;
                  "
                  >View More</span
                >
              </div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createSubPartner"
        @update="updateSubPartner"
        :partner="partner"
        :programs="programs"
        :partners="partners"
        :edit="editMode"
        :partnerId="partnerId"
        from="sp"
        :viewPartner="viewPartner"
      />
    </v-dialog>
    <ConfirmDialog
      v-if="showDialog"
      :show="showDialog"
      @delete="changeConfirmation"
      @close="showDialog = false"
      title="sub partner"
      :name="currentItem.name"
      :active="currentItem.active"
    />
  </div>
</template>

<script>
import formDialog from "@/components/partner/form.vue";
import searchBar from "@/components/searchBar.vue";
import { subPartnerHeaders } from "@/constants/headers";
import ConfirmDialog from "@/components/confirm.vue";

export default {
  components: {
    formDialog,
    searchBar,
    ConfirmDialog,
  },
  props: {
    partnerId: {
      type: Number,
      default: () => 0,
    },
    itemsPerPage: {
      type: Number,
      default: () => 0,
    },
    partners: {
      type: Array,
      default: () => [],
    },
    subPartners: {
      type: Array,
      default: () => [],
    },
    viewPartner: {
      type: Boolean,
      default: () => false,
    },
    searchBar: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      partner: {},
      programs: [],
      sub_partner: {},
      showDialog: false,
      currentItem: {},
      search: "",
      headers: subPartnerHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getPrograms();
    if (this.viewPartner)
      this.headers = this.headers.filter((item) => item.value !== "partner_id");
  },
  methods: {
    goToSubPartnerView(id) {
      this.$router.push({ name: "View Sub Partner", params: { id } });
    },
    initialise() {
      this.$emit("getSubPartners");
    },
    navigate() {
      this.$emit("viewMore", "Sub Partners");
    },
    async createSubPartner(data) {
      data.level = "S";
      data.parent_id = this.partnerId;
      await this.$axios
        .post("partners", { partner: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Sub partner created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateSubPartner(data) {
      await this.$axios
        .put("partners/" + data.id, { partner: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Sub partner updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    changeConfirmation() {
      this.updateSubPartner({
        id: this.currentItem.id,
        active: !this.currentItem.active,
      });
    },
    openConfirm(item) {
      this.showDialog = true;
      this.currentItem = { ...item };
    },
    showActiveStatus(item) {
      return item.active ? "Active" : "Inactive";
    },
    create() {
      this.sub_partner = { partner_id: this.partnerId };
      this.editMode = false;
      this.dialog = true;
    },
    edit(item) {
      const partner_item = {
        ...item,
        adm_approval_reqd: item.partner_approval_required,
        adm_applicant_fee_collect: item.partner_payment_required,
      };
      this.partner = { ...partner_item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.showDialog = false;
      this.currentItem = {};
      this.sub_partner = {};
    },
    getPartner(value) {
      return this.partners.find((partner) => partner.id == value)?.name;
    },
    async getPrograms(){
      await this.$axios.get("/programs").then((res) => {
        this.programs = res.data.data
      })
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const partnerName = this.getPartner(item.partner_id);
      const status = this.showActiveStatus(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        status.toLowerCase().includes(search.toLowerCase()) ||
        partnerName.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
